export const getIconModules = () =>
  import.meta.glob('./assets/*.svg', {
    query: '?url',
    eager: false,
    import: 'default',
  });
